<template>
  <div class="-edit -action" @click="$emit('edit')" v-tooltip="tooltipOptions">
    <span class="wticon wticon-edit-04"></span>
  </div>
</template>

<script>
export default {
  name: 'AssetEdit',
  computed: {
    tooltipOptions() {
      return {
        title: 'Edit',
        placement: 'top auto',
        wrapperClass: 'dark',
        delay: { show: 250, hide: 0 },
        container: '.tooltip-container',
      };
    },
  },
};
</script>
